import { render } from "./VabeneAdminDashPage.vue?vue&type=template&id=439f97ee&scoped=true&ts=true"
import script from "./VabeneAdminDashPage.vue?vue&type=script&lang=ts"
export * from "./VabeneAdminDashPage.vue?vue&type=script&lang=ts"

import "./VabeneAdminDashPage.vue?vue&type=style&index=0&id=439f97ee&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-439f97ee"]])

export default __exports__